require('./brokerOrdersAndMovementsMovementsHeader.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @core
const { FormattedText, formatText } = require('core/i18n').i18n;

// @components
const { OKButton } = require('components/commons/OKButton/OKButton');

// @commons
const { LabelFilterRange } = require('commonsComponents/labelFilterRange');

// @constants
const { DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');


class BrokerOrdersAndMovementsMovementsHeader extends React.Component {

    buildFilterDateLabel() {
        const { immFilter } = this.props;
        const immFilterDate = immFilter.get('date');

        if (immFilterDate.get('isActive') && immFilterDate.get('from') && immFilterDate.get('to')) {
            const labelFromDate = immFilterDate.get('from').format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));
            const labelToDate = immFilterDate.get('to').format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));

            return (
                <LabelFilterRange
                    key="filter-date"
                    from={labelFromDate}
                    to={labelToDate}
                />
            );

        }
    }

    buildHeaderFilters(actionElement, onFilterClick) {
        return (
            <div className="broker-orders-and-movements-movements-header__filters">
                {actionElement}
                <OKButton
                    id="btn_accountLastMovementsHeader_filterButton"
                    modifier="task"
                    onClick={onFilterClick}
                >
                    <i className="icon icon-filtrar broker-orders-and-movements-movements-header__filter-settings-icon" />
                </OKButton>
            </div>
        );
    }

    render() {
        const { onFilterClick, clearFilter, immFilter } = this.props;
        let actionElement;
        let labelFilter;

        if (immFilter && immFilter.get('date').get('isActive')) {
            const filterDateLabel = this.buildFilterDateLabel();

            actionElement = (
                <button className="broker-orders-and-movements-movements-header__button-clean" onClick={clearFilter}>
                    <FormattedText value="filters-clear" format="uppercase" />
                </button>
            );

            labelFilter = (
                <div className="broker-orders-and-movements-movements-header__labels">
                    {filterDateLabel}
                </div>
            );
        } else {
            actionElement = (
                <FormattedText
                    value="filters-all"
                    format="uppercase"
                    className="broker-orders-and-movements-movements-header__label-all"
                />
            );
        }

        const headerFiltersBlock = this.buildHeaderFilters(actionElement, onFilterClick);

        return (
            <header className="broker-orders-and-movements-movements-header">
                <div className="broker-orders-and-movements-movements-header__title">
                    <FormattedText value="broker-ordersAndMovementsMovementsTabValueMovements" />
                </div>
                {headerFiltersBlock}
                {labelFilter}
            </header>
        )
    }
}

BrokerOrdersAndMovementsMovementsHeader.propTypes = {
    immFilter: PropTypes.object.isRequired,
    onFilterClick: PropTypes.func.isRequired,
    clearFilter: PropTypes.func.isRequired,
    hasError: PropTypes.bool
}

module.exports = BrokerOrdersAndMovementsMovementsHeader;
